import useMount from '@src/utils/hooks/use-mount';

import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import NavibarStore from '@src/business-components/navibar/store';
import $$tracker from '@src/tracker';
import { autobind } from 'core-decorators';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { useEffect } from 'react';
class NewsDetailStore extends BaseStore {
  navibarStore = new NavibarStore({ mainStore: this });

  @observable pageNum = 1;
  @observable listData = [];
  @observable allListData = [];
  @observable count = 0;
  @observable pageSize = 8;
  @observable pageTotal = 0;
  @observable commitmentId;
  @observable
  selList = [
    // {
    //   id: 0,
    //   title: '程序&技术类'
    // },
    // {
    //   id: 1,
    //   title: '美术&表现类'
    // },
    // {
    //   id: 2,
    //   title: '程序&技术类'
    // },
    // {
    //   id: 3,
    //   title: '产品策划类'
    // },
    // {
    //   id: 4,
    //   title: '质量管理类'
    // },
    // {
    //   id: 5,
    //   title: '运营类'
    // }
  ];
  /**
   * 点击查看详情
   */
  onDetailClick = item => {
    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';
    $$tracker.clickProject(item.item_title);
    sessionStorage.setItem('from', JSON.stringify(['首页', '招募列表']));
    let newUrlString = currentUrl.toString().replace('list.html', 'article.html');
    newUrlString += `#/?contentId=${item.contentIdKey}`;

    window.location.href = newUrlString;
  };

  @autobind
  changePage(pageNums) {
    // console.log(pageNums, '==pageNums');
    this.pageNum = pageNums;
    this.listData = this.allListData.slice((pageNums - 1) * this.pageSize, pageNums * this.pageSize);
  }

  @autobind
  changeType(checkedValues) {
    // console.log(checkedValues, '==e');
    const lastSelected = [checkedValues[checkedValues.length - 1]];
    this.commitmentId = lastSelected;
    if (checkedValues.length != 0) {
      this.listData = this.allListData.filter(item => item.type_id === this.commitmentId[0]).slice(0, this.pageSize);
      this.pageTotal = this.listData.length;
    }
    if (checkedValues.length === 0) {
      this.pageNum = 1;
      this.listData = this.allListData.slice(0, this.pageSize);
      this.pageTotal = this.allListData.length;
    }
  }
  use() {
    super.use();
    // const layerData = useLayerData('itemList');

    const pageData = useFunLinkPageData();
    // console.log(pageData, 'pageData');

    useEffect(
      () => {
        if (!pageData) {
          return;
        }
        console.log(pageData, '==pageData');

        pageData.recruitTypeList.forEach(item => {
          item.value = item.type_id;
          item.label = item.type_text;
        });
        // this.selList = pageData.recruitTypeList;
        this.allListData = pageData.recruitList;
        this.pageTotal = this.allListData.length;
        this.listData = this.allListData.slice(0, this.pageSize);
        const seen = {};
        this.allListData.forEach(obj => {
          const key = obj.type_id;
          if (!seen[key]) {
            seen[key] = true;
            this.selList.push(obj);
          }
        });
      },
      [pageData]
    );
    useMount(async () => {
      $$tracker.exposePageList();
    });
  }
}

export default NewsDetailStore;
